/** Query param `context` on shared dashboard detail routes (Overview vs Finance, etc.). */
export const DASHBOARD_DETAIL_CONTEXT = {
  finance: 'finance',
  overview: 'overview',
  performance: 'performance',
  operations: 'operations',
  huddle: 'huddle',
} as const

export type DashboardDetailContext =
  (typeof DASHBOARD_DETAIL_CONTEXT)[keyof typeof DASHBOARD_DETAIL_CONTEXT]

const CONTEXT_TAB_LABEL: Record<string, string> = {
  [DASHBOARD_DETAIL_CONTEXT.finance]: 'Finance',
  [DASHBOARD_DETAIL_CONTEXT.overview]: 'Overview',
  [DASHBOARD_DETAIL_CONTEXT.performance]: 'Performance',
  [DASHBOARD_DETAIL_CONTEXT.operations]: 'Operations',
  [DASHBOARD_DETAIL_CONTEXT.huddle]: 'Huddle',
}

/** Hide pagination, search, and filters on detail tables with at most this many rows. */
export const DASHBOARD_DETAIL_MAX_ROWS_WITHOUT_CONTROLS = 5

/** Scrollable tbody height on dashboard detail tables (~8 visible rows). */
export const DASHBOARD_DETAIL_TABLE_BODY_MAX_HEIGHT = '320px'

/** True for drill-down routes such as `/dashboard/forecast` (not the main dashboard index). */
export function isDashboardDetailRoute(pathname: string): boolean {
  return /\/dashboard\/[^/]+/.test(pathname)
}

export function buildDashboardDetailHref(
  path: string,
  params: Record<string, string> = {},
): string {
  const [pathname, search = ''] = path.split('?')
  const query = new URLSearchParams(search)
  Object.entries(params).forEach(([key, value]) => {
    query.set(key, value)
  })
  const qs = query.toString()
  return qs ? `${pathname}?${qs}` : pathname
}

export function getDashboardDetailBreadcrumbTrail(
  sectionLabel: string,
  context: string | null,
  fallbackTabLabel: string,
): string {
  const tabLabel = (context && CONTEXT_TAB_LABEL[context]) || fallbackTabLabel
  return `${tabLabel} / ${sectionLabel}`
}

export function getArAgingDetailBreadcrumbTrail(
  context: string | null,
): string {
  return getDashboardDetailBreadcrumbTrail('AR aging', context, 'Overview')
}
